import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';

import type { UnpluginIcon } from '@adflow/frontend/ui-assets';
import { theme, typography } from '@adflow/frontend/ui-theme';

const styles = {
	container: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '5rem',
	}),
	icon: css({ width: '100%', height: '100%', color: theme.colors.text.hint }),
	message: css(typography.emptyLarge, {
		textAlign: 'center',
	}),
};

interface EmptyRowProps {
	outerStyle?: CSSInterpolation;
	Icon: UnpluginIcon;
	iconStyle?: CSSInterpolation;
	message?: string;
	messageStyle?: CSSInterpolation;
}

export function EmptyRow(props: EmptyRowProps) {
	return (
		<div css={[styles.container, props.outerStyle]} data-testid="empty-row">
			<props.Icon css={[styles.icon, props.iconStyle]} />
			{props.message ? (
				<div css={[styles.message, props.messageStyle]}>{props.message}</div>
			) : null}
		</div>
	);
}
